const ulrMap = (centerString, stringLAnd, stringFarm) => {
  const url = `https://maps.googleapis.com/maps/api/staticmap?center=${centerString.lat},${centerString.lng}&format=png&&zoom=14&size=400x400&key=AIzaSyB2y51RMPCAp71PSkWMRGVjYbdfhIXOOJQ&maptype=satellite&path=color:0xffffff|weight:2|${stringLAnd}${
    stringFarm ? `&path=color:0xffffff|weight:2|${stringFarm}` : ''
  }`
  return url
}

export default ulrMap
